// Trang trắc nghiệm - chọn đề, làm bài từng câu, xem kết quả
import React, { useState } from 'react';
import QuizList from './QuizList';
import Quiz from './Quiz';
import QuizResult from './QuizResult';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Logo from "../../images/caobangceritage.svg"

const TracNghiemPage = () => {
  const [selectedQuiz, setSelectedQuiz] = useState(null); // id đề
  const [quizState, setQuizState] = useState('list'); // 'list' | 'doing' | 'result'
  const [userAnswers, setUserAnswers] = useState([]); // [{cauHoiId, answer}]
  const [score, setScore] = useState(null);

  // Khi chọn đề
  const handleSelectQuiz = (quizId) => {
    setSelectedQuiz(quizId);
    setQuizState('doing');
    setUserAnswers([]);
    setScore(null);
  };

  // Khi nộp bài
  const handleSubmitQuiz = (answers, score) => {
    setUserAnswers(answers);
    setScore(score);
    setQuizState('result');
  };

  // Làm lại đề
  const handleResetQuiz = () => {
    setUserAnswers([]);
    setScore(null);
    setQuizState('doing');
  };

  // Quay lại danh sách đề
  const handleBackToList = () => {
    setSelectedQuiz(null);
    setQuizState('list');
    setUserAnswers([]);
    setScore(null);
  };

  return (
    <div className="quiz-modern-wrapper">
      <Header Logo={Logo} hclass="header-style-1" />
      {/* Nhạc nền */}
      <audio src="https://cdn.pixabay.com/audio/2022/10/16/audio_12b6fae5b6.mp3" autoPlay loop volume={0.15} style={{ display: 'none' }} />
      <main style={{ minHeight: '70vh', background: '#f6f8fa' }}>
        {quizState === 'list' && (
          <QuizList onSelectQuiz={handleSelectQuiz} />
        )}
        {quizState === 'doing' && selectedQuiz && (
          <Quiz quizId={selectedQuiz} onSubmit={handleSubmitQuiz} onBack={handleBackToList} />
        )}
        {quizState === 'result' && selectedQuiz && (
          <QuizResult quizId={selectedQuiz} userAnswers={userAnswers} score={score} onRetry={handleResetQuiz} onBack={handleBackToList} />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default TracNghiemPage; 